import { render, staticRenderFns } from "./FamilyProfile.vue?vue&type=template&id=058a4706"
import script from "./FamilyProfile.vue?vue&type=script&lang=js"
export * from "./FamilyProfile.vue?vue&type=script&lang=js"
import style0 from "./FamilyProfile.vue?vue&type=style&index=0&id=058a4706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports